// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__r9iLJ","disabled":"FileBtn_disabled__ECPH6","warn":"FileBtn_warn__63Iyf","fade":"FileBtn_fade__2elJM"};